import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=56bb3c1a&scoped=true"
import script from "./card-item.vue?vue&type=script&lang=js"
export * from "./card-item.vue?vue&type=script&lang=js"
import style0 from "./card-item.vue?vue&type=style&index=0&id=56bb3c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bb3c1a",
  null
  
)

export default component.exports